<template>
    <div v-if="json" class="content-blocks">
        <template v-for="(block, index) in json.contentBlocks" :key="index">
            <component
                :is="componentName(block.type)"
                :json="block"
                :allJson="json"
                data-aos="custom-fade-in"
            ></component>
        </template>
    </div>
</template>
<script>

import GenericText from '@/components/blocks/GenericText'
import ImageStrip from '@/components/blocks/ImageStrip'
import QuoteBlock from '@/components/blocks/QuoteBlock'

import gh from '@/helpers/gh'
export default {
    name: "ContentBlocks",
    components: {
        GenericText,
        ImageStrip,
        QuoteBlock
    },
    props: {
        json: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            gh: gh,
        }

    },
    created () {
    },
    mounted () {

    },
    methods: {
        componentName(type) {
            switch (type) {
                case 'richText':
                    return GenericText
                case 'imageStrip':
                    return ImageStrip
                case 'quote':
                    return QuoteBlock
            }
        }
    }
}
</script>
